import { get, ref } from 'firebase/database';
import { db } from '../config/firebase';
import { WEBSITE_HERO_ROOT } from '../config/websiteHero';
import { WebsiteHeroPublishedItem } from '../types/websiteHero.types';
import { isWebsiteHeroId, isWebsiteHeroImageUrl, validateWebsiteHeroDetails } from '../utils/websiteHeroUpload';

/** Read the small public index only; never read or fall back to the app catalogue. */
export async function getWebsiteHeroMedia(): Promise<WebsiteHeroPublishedItem[]> {
  const snapshot = await get(ref(db, `${WEBSITE_HERO_ROOT}/published`));
  const items: WebsiteHeroPublishedItem[] = [];
  snapshot.forEach(child => {
    const record = child.val();
    if (!isWebsiteHeroId(child.key) || !record || typeof record !== 'object' || Array.isArray(record) ||
      !isWebsiteHeroImageUrl(record.imageUrl, child.key)) return;
    try {
      const details = validateWebsiteHeroDetails(record);
      items.push({ id: child.key, ...details, imageUrl: record.imageUrl });
    } catch {
      // One malformed record must not prevent other published designs loading.
    }
  });
  return items.sort((a, b) => a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
}
